import api from '../api';

const getDefaultState = () => ({
    carriers: [],
    plans: [],
    retailersTags: [],
    simcards: [],
    isLoading: false,
    hasQuried: false,
    modalShown: false,
    tagIdAssignTo: null,
    selectedCarrierId: null,
    selectedStatusId: null,
    selectedFilterType: null,
    filterContent: null,
    selectedRange: {
        start: null,
        end: null
    },
});

export const simcardList = {
    namespaced: true,

    state: getDefaultState(),

    getters: {

        carrierNameMap(state) {
            return state.carriers.reduce((map, carrier) => {
                map[carrier.id] = carrier.name;
                return map;
            }, {});
        },

        planNameMap(state) {
            return state.plans.reduce((map, plan) => {
                map[plan.id] = plan.desc;
                return map;
            }, {});
        },

        retailersTagsMag(state) {
            return state.retailersTags.reduce((map, retailersTag) => {
                map[retailersTag.id] = retailersTag.name;
                return map;
            }, {});
        },

        simcardsHasChecked(state) {
            return state.simcards.filter(simcard => simcard.checked);
        },

        numOfSimcardsHasChecked(state, getters) {
            return getters.simcardsHasChecked.length;
        },

        anySimcardsHasChecked(state, getters) {
            return getters.numOfSimcardsHasChecked > 0;
        },

    },

    mutations: {

        resetState(state) {
            Object.assign(state, getDefaultState());
        },

        setCarriers(state, carriers) {
            state.carriers = carriers;
        },
        setRetailersTags(state, retailersTags) {
            state.retailersTags = retailersTags;
        },
        setPlans(state, plans) {
            state.plans = plans;
        },
        setSimcards(state, simcards) {
            state.simcards = simcards;
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setHasQuried(state, hasQuried) {
            state.hasQuried = hasQuried;
        },
        setModalShown(state, modalShown) {
            state.modalShown = modalShown;
        },
        setTagIdAssignTo(state, tagIdAssignTo) {
            state.tagIdAssignTo = tagIdAssignTo;
        },
        setSelectedCarrierId(state, selectedCarrierId) {
            state.selectedCarrierId = selectedCarrierId;
        },
        setSelectedStatusId(state, selectedStatusId) {
            state.selectedStatusId = selectedStatusId;
        },
        setSelectedRange(state, selectedRange) {
            state.selectedRange = selectedRange;
        },
        setSelectedFilterType(state, val) {
            state.selectedFilterType = val;
        },
        setFilterContent(state, val) {
            state.filterContent = val;
        },
    },

    actions: {

        fetchCarriers({ commit }) {

            api.getCarriers()
                .then(
                    res => {
                        let carriers = res.data.data;
                        carriers.sort(function(e1, e2) {
                            switch (true) {
                                case e1.name < e2.name:
                                    return -1;
                                case e1.name > e2.name:
                                    return 1;
                                default:
                                    return 0;
                            }
                        })
                        commit('setCarriers', carriers);
                    }
                )
        },

        fetchRetailersTags({ commit }) {

            api.getRetailersTags()
                .then(
                    res => {
                        let retailersTags = res.data.data;
                        commit('setRetailersTags', retailersTags);
                    }
                )
        },

        fetchPlans({ commit }) {

            api.getPlans()
                .then(
                    res => {
                        let plans = res.data.data;
                        commit('setPlans', plans);
                    }
                )
        },

        fetchSimcards({ commit }, { status, carrier_id, from, to, type, text }) {

            commit('setIsLoading', true);

            api.getSimcards(
                status,
                carrier_id,
                status == 0 ? null : from,
                status == 0 ? null : to,
                type,
                text,
            ).then(
                res => {
                    let simcards = res.data.data;
                    simcards = simcards.map(simcard => {
                        simcard.checked = false;
                        return simcard;
                    });
                    commit('setSimcards', simcards);
                    commit('setHasQuried', true);
                    commit('setIsLoading', false);
                }
            ).catch(() => commit('setIsLoading', false));
        },

        fetchReport(b, { status, carrier_id, from, to }) {

            return api.getReport(
                status,
                carrier_id,
                status == 0 ? null : from,
                status == 0 ? null : to
            ).then(
                res => {
                    console.log(res.data)
                    return res.data;
                }
            )
        },

        changeTagId({ commit }, { tagId }) {
            commit('setTagIdAssignTo', tagId);
        },

        quit({ commit }) {
            commit('setSimcards', []);
            commit('setHasQuried', false);
        },

        toggleSimcard({ state, commit }, { simcard_no, checked }) {

            console.log(simcard_no, checked)
            const simcards = state.simcards.map(simcard => {
                if (simcard.simcard_no == simcard_no) {
                    simcard.checked = checked;
                }
                return simcard;
            });

            commit('setSimcards', simcards);

        },

        assignTagToSimcards({ state, dispatch }, { tagId, simcards }) {

            const simcardNos = simcards.map(simcard => simcard.simcard_no);

            api.assignTagToSimcards(tagId, simcardNos)
                .then(
                    res => {
                        console.log(res)

                        dispatch('closeModal');
                        dispatch('fetchSimcards', {
                            status: state.selectedStatusId,
                            carrier_id: state.selectedCarrierId,
                            from: state.selectedRange ? state.selectedRange.start : null,
                            to: state.selectedRange ? state.selectedRange.end : null,
                        })
                    }
                );

        },

        openModal({ commit }) {
            commit('setModalShown', true);
        },

        closeModal({ commit }) {
            commit('setModalShown', false);
        },

    }

};